<template>
    <div class="sidebar">
        <el-menu class="sidebar-el-menu" :unique-opened="true"  :default-active="onRoutes" :collapse="collapse"  router>
          <el-menu-item index="/" key="index">
            <i class="el-icon-s-home"></i>
            <template slot="title">首页</template>
          </el-menu-item>
            <template v-for="item in items">
                <template v-if="item.child  instanceof Array">
                    <el-submenu :index="item.id + ''" :key="item.id">
                        <template slot="title">
                            <i :class="item.icon"></i>
                            <span>{{ item.name }}</span>
                        </template>
                        <template v-for="subItem in item.child">
                            <el-submenu v-if="subItem.child instanceof Array" :index="subItem.id + ''" :key="subItem.id">
                                <template slot="title">{{ subItem.name }}</template>
                                <el-menu-item v-for="(threeItem, i) in subItem.child" :key="i" :index="threeItem.route">
                                    {{ threeItem.name }}</el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else :index="subItem.route" :key="subItem.id">{{ subItem.name }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.route" :key="item.id">
                        <i :class="item.icon"></i>
                        <template slot="title">{{ item.name }}</template>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
</template>

<script>
import {getUserMenu} from '../api/auth'

export default {
  data () {
    return {
      items: [],
      defaultOpeneds: [],
      onRoutes: '',
      collapse: false,
      documentWidth: 1920
    }
  },
  watch: {
    documentWidth (val) {
      this.documentWidth = val
      this.getWidth()
    }
  },
  mounted () {
    this.onRoutes = this.$router.currentRoute.fullPath
    this.setMenuList()
    this.getWidth()
    window.onresize = () => {
      return (() => {
        this.documentWidth = document.body.clientWidth
      })()
    }
    this.documentWidth = document.body.clientWidth
    this.getWidth()
  },
  methods: {
    getWidth () {
      if (this.documentWidth < 1500) {
        this.$store.commit('setCollapse', true)
      } else {
        this.$store.commit('setCollapse', false)
      }
      this.collapse = this.$store.state.collapse
    },
    setMenuList () {
      getUserMenu().then(res => {
        let {status, data} = res
        if (status === 2000) {
          this.items = data
          this.setDefaultOpenMenu()
        } else {
          this.items = []
        }
      })
    },
    setDefaultOpenMenu () {
      this.defaultOpeneds = []
      if (this.onRoutes !== '/index') {
        this.items.forEach((item, index) => {
          let currRoute = item.child.find(res => res.route === this.onRoutes)
          if (currRoute) {
            this.defaultOpeneds.push(item.id + '')
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.sidebar::-webkit-scrollbar {
    width: 0;
}
.sidebar {
  display: inline-block !important;
}
.sidebar .el-menu--collapse{
  width: 64px!important;
}

.sidebar-el-menu:not(.el-menu--collapse) {
    width: 200px;
}
.sidebar {
  min-height: calc(100vh - 60px);
  height: 100%;
  max-height: calc(100vh - 30px);
}
.sidebar > ul {
  height: 99%;
  /*overflow-y: scroll!important;*/
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue